import Increment from './Increment'

export default Increment
